import BaseAPI from '@/apis/base/baseApi';

class WebsiteIssuesAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'websiteIssues';
}

export default new WebsiteIssuesAPI();
